/**
 * 任务指派
 * 2019-05-08
 * qian.qianchen
 */
"use strict";
angular.module("taskAssignmentModule", [
    "assignmentsModule", //任务指派模块
    "myAssignmentsModule", //我的任务模块
    "taskAssignmentLeftModule", //左侧导航模块
    "taskAssignmentRouterModule", //任务指派总路由
    "editAssignmentModule", //新建/编辑任务
    "taskAssignmentServiceModule", //任务指派服务
    "opinionPosCalculateModule", //位置调整指令
]).
controller("taskAssignmentCtrl", [function() {

}]);